import { render } from "./PlanContable_Cuenta.vue?vue&type=template&id=d1e9b65e&scoped=true"
import script from "./PlanContable_Cuenta.vue?vue&type=script&lang=js"
export * from "./PlanContable_Cuenta.vue?vue&type=script&lang=js"

import "@/assets/css/alertas.css?vue&type=style&index=0&id=d1e9b65e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e9b65e"]])

export default __exports__